import { Nav, TabContent } from "reactstrap";
import Layout from "../../../components/custom/Layout";
import CustomNavItem from "../../../components/custom/CustomNavItem";
import { useState } from "react";
import CustomTabPane from "../../../components/custom/CustomTabPane";
import Pending from "./Pending";
import Active from "./Active";

export type Tab = 'pending' | 'active';

export default function ManageDisplays() {

    const [activeTab, setActiveTab] = useState<Tab>('pending');
    const toggleTab = (tab: Tab) => setActiveTab(tab);

    return (
        <Layout>
            <Nav tabs className={'separator-tabs'}>
                <CustomNavItem<Tab>
                    tabName="Pending"
                    tabId="pending"
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
                <CustomNavItem<Tab>
                    tabName="Active"
                    tabId="active"
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
            </Nav>
            <TabContent activeTab={activeTab} className={'mt-2'}>
                <CustomTabPane<Tab> tabId={'pending'}>
                    <Pending 
                        activeTab={activeTab}
                    />
                </CustomTabPane>
                <CustomTabPane<Tab> tabId={'active'}>
                    <Active 
                        activeTab={activeTab}
                    />
                </CustomTabPane>
            </TabContent>
        </Layout>
    );
}